import LoadingDots from "@components/_Layout/Loaders/LoadingDots";
import PropTypes from "prop-types";
import React from "react";
import Select, {
  components,
  ControlProps,
  GroupBase,
  LoadingIndicatorProps,
  OptionsOrGroups,
} from "react-select";
import { SelectOptionType } from "../../../../types";
import { StateManagerProps } from "react-select/dist/declarations/src/stateManager";

interface AdvancedSelectProps extends StateManagerProps {
  options: OptionsOrGroups<unknown, GroupBase<unknown>> | SelectOptionType[];
}

const AdvancedSelect: React.FC<AdvancedSelectProps> = ({ ...props }) => {
  return (
    <>
      <Select
        className={`${props.isMulti ? "basic-multi-select" : "basic-select"}`}
        {...props}
        styles={{
          control: (provided, state) => ({
            ...provided,
            boxShadow: "none",
            padding: "0.125rem 0",
          }),
          option: (base, { isFocused, isSelected }) => ({
            ...base,
            background: isFocused
              ? "#50bed5"
              : isSelected
                ? "#50bed5"
                : undefined,
            "&:hover:": {
              background: "#cceff0",
            },
            ":active": {
              ...base[":active"],
              background: "#008a8f",
            },
          }),
        }}
        classNamePrefix="react-select"
        components={{ LoadingIndicator, Control }}
        value={props.options.length === 1 ? props.options[0] : props.value}
      />
    </>
  );
};

//Loading Indicator overwrite
const LoadingIndicator = (props: LoadingIndicatorProps<any>) => {
  return (
    <div className="tw-flex tw-mx-2">
      <LoadingDots />
    </div>
  );
};

//Control overwrite
const Control = (props: ControlProps) => (
  <components.Control {...props} className="react-select-border-primary-500" />
);

AdvancedSelect.propTypes = {
  options: PropTypes.array.isRequired,
};

export default AdvancedSelect;
